import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

import { USER_QUERY } from '../app/graphql/authQueries';
import { HeaderLogo } from '../components/Logo';
import { extractGraphqlEntity } from '../common/utils/graphqlUtils';
import SimpleDialog from '../components/dialogs/SimpleDialog';
import { useEmailProcessingDialogStyles } from './useEmailProcessingDialog.styles';

export function useEmailProcessingDialog({ documentType, paragraph2Id }) {
  const [open, setOpen] = useState(false);

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  const dialog = (
    <EmailProcessingDialog
      documentType={documentType}
      open={open}
      onCancel={closeDialog}
      paragraph2Id={paragraph2Id}
    />
  );

  return { openDialog, dialog };
}

export default function EmailProcessingDialog({
  documentType,
  open,
  onCancel,
  paragraph2Id,
}) {
  const { data } = useQuery(USER_QUERY);
  const { email } = extractGraphqlEntity(data);
  const { styles } = useEmailProcessingDialogStyles();

  return (
    <SimpleDialog
      open={open}
      onCancel={onCancel}
      mask
      maskClosable
      className={styles.emailProcessingDialog}
    >
      <HeaderLogo size="sm" />
      <Typography.Title level={1}>
        <FormattedMessage
          id="emailProcessingDialog.title"
          values={{ documentType }}
        />
      </Typography.Title>
      <Typography.Title level={4} className="nl-as-newline">
        <FormattedMessage
          id="emailProcessingDialog.paragraph1"
          values={{ documentType }}
        />
        <br />
        <br />
        <FormattedMessage
          id={paragraph2Id}
          values={{ documentType, email: <strong>{email}</strong> }}
        />
        <br />
        <br />
        <FormattedMessage id="emailProcessingDialog.paragraph3" />
      </Typography.Title>
    </SimpleDialog>
  );
}
